// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 角色类型枚举 枚举类
 * 角色类型枚举，定义系统的默认角色
 */
export enum EnumRoleType {
  /** 平台管理员 : 平台管理员，对平台实体具有管理权限 */
  PlatManager = 1,
  /** 应用管理员 : 应用管理员，对租户实体具有管理权限 */
  AppManager = 2,
  /** 应用用户 : 应用用户，应用的使用用户，提供给租户内子账户 */
  AppUser = 4
}

/**
 * 角色类型枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumRoleTypeMD {
  private static items = [
    new EnumItemMD('PlatManager', 1, '平台管理员', '平台管理员，对平台实体具有管理权限'),
    new EnumItemMD('AppManager', 2, '应用管理员', '应用管理员，对租户实体具有管理权限'),
    new EnumItemMD('AppUser', 4, '应用用户', '应用用户，应用的使用用户，提供给租户内子账户')
  ];

  static getItem(enumItem: EnumRoleType) {
    return this.items.find(item => item.name === EnumRoleType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
